<template>
    <div id="thankyou-model" class="thankyou-model" data-component-name="thank-you-popup">
        <ul class="list-unstyled contact-form">
            <li style="text-align:center;"><img src="../../assets/images/ty-ovation.png" class="img-fluid top-img" /></li>
            <li>
                <div class="thank-you-for-your-r">Thank you for your request.</div>
            </li>
            <li>
                <div class="one-of-our-credit-sp">One of our credit specialist from Ovation Credit Services (a LendingTree company) will contact you soon.</div>
            </li>
            <li>
                <div class="learn-More-about-cre">Learn More about Credit Repair</div>
            </li>
            <li>
                <div class="div-logos"><img src="https://s3.amazonaws.com/lt-preprime/images/ovation_logo.png" class="img-fluid img-lt" /></div>
            </li>
        </ul>
    </div>
</template>

<script>
    export default { };
</script>

<style lang="scss">
@import "../../assets/styles/variables";

.thankyou-model {
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    margin-top: -5px;

    .top-img {
        width: 160px;
        height: 145px;
    }

    .thank-you-for-your-r {
        width: 100%;
        font-family: "DM Serif Display", "Times New Roman", serif;
        font-size: 32px;
        color: #08c177;
        line-height: 1.19;
        padding-top: 15px;

        @media #{$mob-portrait-view} {
            font-size: 40px;
        }
    }

    .one-of-our-credit-sp {
        width: 100%;
        font-family: "Lato", Arial, sans-serif;
        font-size: 16px;
        line-height: 1.65;
        color: #454545;
        padding-top: 15px;

        @media #{$mob-portrait-view} {
            font-size: 24px;
        }
    }

    .learn-More-about-cre {
        width: 100%;
        font-family: "Lato", Arial, sans-serif;
        font-size: 18px;
        font-weight: bold;
        line-height: 1.56;
        letter-spacing: 1px;
        color: #101f30;
        padding-top: 20px;
        text-transform: uppercase;

        @media #{$mob-portrait-view} {
            font-size: 22px;
        }
    }

    .div-logos {
        padding-top: 15px;
        margin-bottom: -5px;
    }
}
</style>
